import type { Translation } from '../types.ts';
import type en from '../en/users.ts';

export default {
    roles: {
        superAdmin: 'Superbeheerder',
        admin: 'Beheerder',
        editor: 'Redacteur',
        designer: 'Designer',
    },
    shared: {
        newUser: 'Nieuwe gebruiker',
        role: 'Rol',
        websites: 'Websites',
        lastLogin: 'Laatst ingelogd',
    },
    list: {
        title: 'Gebruikers',
        impersonate: 'Inloggen als',
        confirmImpersonate: 'Inloggen als {email}? Je ziet de admin precies zoals deze gebruiker hem ziet, tot je teruggaat naar je eigen account.',
        empty: 'Nog geen gebruikers.',
    },
    edit: {
        created: 'Gebruiker aangemaakt',
        confirmDelete: 'Gebruiker {email} verwijderen?',
        websitesHint: 'Vink elke website aan waar deze gebruiker toegang toe moet hebben.',
        password: 'Wachtwoord',
        passwordHint: 'Laat leeg om het huidige wachtwoord te houden.',
    },
} satisfies Translation<typeof en>;
